import { ACTION_SAVE_CLIENT_PENDING, ACTION_SAVE_CLIENT_SUCCESS, ACTION_SAVE_CLIENT_ERROR } from 'actions/client/action.client-save';

const initialState = {
    saveClientPending: false,
    saveClientError: null
}

export default function saveClientReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_SAVE_CLIENT_PENDING:
            return {
                ...state,
                saveClientPending: true
            }
        case ACTION_SAVE_CLIENT_SUCCESS:
            return {
                ...state,
                saveClientPending: false
            }
        case ACTION_SAVE_CLIENT_ERROR:
            return {
                ...state,
                saveClientPending: false,
                saveClientError: action.saveClientError
            }
        default:
            return state;
    }
}

export const saveClientPending = state => state.saveClientReducer.saveClientPending;
export const saveClientError = state => state.saveClientReducer.saveClientError;
